import { MapaApostas } from './../../../models/Jogo/mapaApostas';
import { ConfigBloqueios } from './../../../models/Configuracoes/configBloqueios';
import { ConfigCotacoes } from './../../../models/Configuracoes/configCotacoes';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'app/core/config/app.config';
import CryptoJS from 'crypto-js';
import { Observable, of, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export enum TipoJogos {
  AOVIVO = 'Ao Vivo',
  HOJE = 'hoje',
  AMANHA = 'amanha',
  DEPOIS = 'depois'
}

@Injectable({
    providedIn: 'root'
})
export class JogosService {

    private dispararJogosSource = new Subject<TipoJogos>();
  dispararJogos$ = this.dispararJogosSource.asObservable();

  dispararJogos(tipo: TipoJogos) {
    this.dispararJogosSource.next(tipo);
  }

    secretKey = "cRfUjWnZr4u7x!A%";

    constructor(private http: HttpClient) { }

    encriptar(bilhete: string): string {
        const encodedWord = CryptoJS.enc.Utf8.parse(bilhete); // encodedWord Array object
        const encoded = CryptoJS.enc.Base64.stringify(encodedWord); // string: 'NzUzMjI1NDE='
        return "y" + encoded;
    }

    desencriptar(bilhete: string) {
        const encodedWord = CryptoJS.enc.Base64.parse(bilhete.substring(1)); // encodedWord via Base64.parse()
        const decoded = CryptoJS.enc.Utf8.stringify(encodedWord); // decode encodedWord via Utf8.stringify() '75322541'
        return decoded;
    }

    public async jogosAoVivo(): Promise<Observable<any>> {
        return await this.http.get(apiUrl + 'v1/jogos/aovivo').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public async jogosDeHoje(): Promise<Observable<any>> {
        return await this.http.get(apiUrl + 'v1/jogos/hoje').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public async jogosDeAmanha(): Promise<Observable<any>> {
        return await this.http.get(apiUrl + 'v1/jogos/amanha').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public async jogosDeDepois(): Promise<Observable<any>> {
        return await this.http.get(apiUrl + 'v1/jogos/depois').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public async mercadosAoVivo(id: string): Promise<Observable<any>> {
        return await this.http.post(apiUrl + 'v1/jogos/mercados-aovivo', { id_jogo: id }).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public async mercados(id: string): Promise<Observable<any>> {
        return await this.http.post(apiUrl + 'v1/jogos/mercados', { id_jogo: id }).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public getMapaApostas(): Observable<any> {
        return this.http.get(apiUrl + 'v1/jogos/mapa-apostas').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public getDetalhesMapaApostas(jogo: MapaApostas): Observable<any> {
        return this.http.post(apiUrl + 'v1/jogos/mapa-detalhes', {id_jogo: jogo.id_jogo}).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    public criarRegraCotacao(config: ConfigCotacoes) {
        return this.http.put(apiUrl + 'v1/jogos/criar-regra-cotacao', config, { responseType: 'text' });
    }

    public criarRegraBloqueio(config: ConfigBloqueios) {
        return this.http.put(apiUrl + 'v1/jogos/criar-regra-bloqueio', config, { responseType: 'text' });
    }
}
